import { MachineClaiming } from 'app/modules/machine-directory/machine-claiming/components/MachineClaiming/MachineClaiming';

export const MachineClaimingPage = (): JSX.Element => <MachineClaiming />;
